<template>
  <section v-if="!vm.isMobile" class="personality-art">
    <div class="personality-art__screen-wrap">
      <img
        v-lazy="require('../../assets/personality/personality-art-8.jpg')"
        :class="['wow artScreensIn normal-screen screnn-big', { lowOpacity: transScreenOpacity }]"
        data-wow-duration="0.4s"
        data-wow-delay="0.3s"
        alt="ColorOS 11 Art+"
      />
      <template v-for="n in 7">
        <img
          v-if="n !== 2"
          :key="n"
          v-lazy="require('../../assets/personality/personality-art-' + n + '.jpg')"
          :class="['wow artScreensIn normal-screen', { lowOpacity: transScreenOpacity }]"
          data-wow-duration="0.4s"
          data-wow-delay="0.3s"
          alt="ColorOS 11 Art+"
        />
        <div v-else :key="n" class="personality-art-phone">
          <img
            id="artPhoneWap"
            v-lazy="require('../../assets/personality/personality-art-screen.jpg')"
            :style="{ visibility: showPlaceholderScreen ? 'visible' : 'hidden' }"
            class="screen"
            alt="ColorOS 11 Art+ 壁纸"
          />
          <img
            v-lazy="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/art-desktop.png`)"
            :style="{ opacity: 1 - toRelaxOpacity * 2 }"
            class="screen desktop"
            alt
          />
        </div>
      </template>
      <div id="phoneWap">
        <RelaxVideos
          v-if="!vm.isMobile"
          v-show="toRelaxOpacity > 0"
          ref="relaxVideos"
          class="screen"
          :style="{ opacity: toRelaxOpacity }"
          :city-on-playing="cityOnPlaying"
        ></RelaxVideos>
        <img v-lazy="require('../../assets/personality/phone-wrap.png')" class="phone" alt="ColorOS 11 art+ 壁纸" />
      </div>
    </div>
    <div class="personality-art__text">
      <div :style="{ transform: textTransform }" :class="['text-wrap', { 'js-trigger__text-in': textIn }]">
        <div class="title">{{ $t('personality-art+-title') }}</div>
        <div class="sub-title">{{ $t('personality-art+-sub-title') }}</div>
        <div class="description">
          {{ $t('personality-art+-description') }}
          <sup v-if="lang !== 'zh'">2</sup>
        </div>
        <div class="logo-wrap">
          <img v-if="vm.lang === 'zh'" v-lazy="require('../../assets/personality/art-logo.gif')" class="art-logo" alt />
          <img v-else v-lazy="require('../../assets/personality/Artist-logo.png')" class="art-logo artist-logo" />
        </div>
      </div>
    </div>
  </section>
  <section v-else class="personality-art-h5">
    <div class="text-wrap text-intro">
      <div class="title">{{ $t('personality-art+-title') }}</div>
      <div class="sub-title">{{ $t('personality-art+-sub-title') }}</div>
      <div class="description">
        {{ $t('personality-art+-description') }}
        <sup v-if="lang !== 'zh'">2</sup>
      </div>
    </div>
    <template>
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="n in [1, 3, 4, 5, 6, 7, 8]" :key="n">
          <img
            :data-src="require('../../assets/personality/personality-art-' + n + '.jpg')"
            class="swiper-lazy"
            alt="ColorOS 11 Art+ 壁纸"
          />
        </swiper-slide>
      </swiper>
    </template>

    <div id="phoneWap">
      <img
        v-lazy="require(`../../assets${vm.lang === 'zh' ? '/zh' : ''}/personality/art-desktop.png`)"
        class="desktop"
        alt
      />
      <img v-lazy="require('../../assets/personality/phone-wrap.png')" class="phone" alt="ColorOS 11 art+ 壁纸" />
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import RelaxVideos from './RelaxVideos';
import EventBus from './js/eventBus';
export default {
  inject: ['vm', 'lang'],
  components: {
    RelaxVideos
  },
  data() {
    return {
      width: window.innerWidth,
      showPlaceholderScreen: false,
      textIn: false,
      screensOffset: screen.availHeight,
      delta: {},
      transScreenOpacity: false,
      textTransform: 'translate3d(0px,0px,0px)',
      swiperOptions: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        loop: true,
        loopedSlides: 5,
        lazy: {
          loadPrevNextAmount: 3,
          loadPrevNext: true
        }
      },
      toRelaxOpacity: 0,
      cityOnPlaying: 'beijing'
    };
  },
  watch: {
    showPlaceholderScreen(newValue) {
      this.$nextTick(() => {
        this.darkScreenDom.style.visibility = newValue ? 'hidden' : 'visible';
      });
    }
  },
  created() {
    EventBus.$on('setCityOnPlaying', args => {
      this.cityOnPlaying = args;
    });
    EventBus.$on('setToRelaxOpacity', args => {
      this.toRelaxOpacity = args;
    });

    EventBus.$on('playRelax', () => {
      this.$refs.relaxVideos.handlePlaying();
    });
    EventBus.$on('setVoiceVolume', args => {
      this.$refs.relaxVideos.setVoiceVolume(args);
    });
  },
  mounted() {
    if (!this.vm.isMobile) {
      console.log('init art+');
      this.initScene();
    }

    // window.addEventListener('resize', () => {
    //   this.scence.refresh();
    //   this.scence2.refresh();
    //   console.log('relax resize');
    // });
  },
  beforeDestroy() {},
  methods: {
    initScene() {
      //处理壁纸由暗色模式->art+转场动画
      this.scence = new ScrollMagic.Scene({
        duration: screen.availHeight * 0.75,
        triggerElement: '.personality-art',
        offset: 150,
        triggerHook: 1
      }).addTo(Controller);
      this.scence.on('enter', () => {
        //进入art+转场后，不论前进还是后退都是转场壁纸显示，暗色壁纸隐藏
        this.getDarkScreenInfo();
        this.showDarkScreens('transaction');
        this.computingStyles();
      });
      this.scence.on('start', event => {
        //art+  转场到 暗色模式结束，切换显示的壁纸为占位壁纸
        if (event.scrollDirection === 'REVERSE') {
          this.showDarkScreens();
        }
      });
      // this.scence.on('end', event => {
      //   console.log('in art+ end');
      // });
      this.scence.on('progress', event => {
        this.handleScreenTransition(event);
      });
      //处理 art+ 壁纸透明度以及文字运动
      this.scence2 = new ScrollMagic.Scene({
        duration: screen.availHeight * 1.5,
        triggerElement: '.personality-art',
        offset: 0,
        triggerHook: 0
      })
        .setPin('.personality-art')
        .addTo(Controller);
      this.scence2.on('progress', event => {
        let { progress } = event;
        if (progress < 0.25 && this.transScreenOpacity) this.transScreenOpacity = false;
        if (progress >= 0.25) this.transScreenOpacity = true;
        if (progress >= 0.75) this.textIn = true;
        if (progress <= 0.75 && progress > 0.25 && this.textIn) {
          this.computingStylesOfText();
          this.textTransform = `translate3d(0px,${this.delta.textTransformMax * (1 - (progress - 0.25) * 2)}px,0px)`;
        }
      });
      this.scence2.on('start', event => {
        if (event.scrollDirection === 'FORWARD') {
          this.showPlaceholderScreen = true;
        } else if (event.scrollDirection === 'REVERSE') {
          this.showPlaceholderScreen = false;
        }
      });
    },
    handleScreenTransition(event) {
      // console.log(event.progress);
      this.computingStyles();
      let { progress } = event;
      let screenDom = this.darkScreenDom;
      //获取运动壁纸跟随滚动的translateY值
      let initTranlateY = 0;
      let { deltaWidth, deltaHeight, deltaX, deltaY, borderRadius } = this.delta;
      screenDom.style.width = this.screenPosition.width + deltaWidth * progress + 'px';
      screenDom.style.height = this.screenPosition.height + deltaHeight * progress + 'px';
      screenDom.style.borderRadius = 14 + borderRadius * progress + 'px';
      let transVale = `translate3d(${deltaX * progress}px,${initTranlateY + deltaY * progress}px,0px)`;
      screenDom.style.transform = transVale;
      // hack ie 位移
      screenDom.setAttribute('transform', transVale);
      // console.log(progress);
    },
    //获取暗色模式的两张壁纸
    getDarkScreenInfo() {
      this.darkScreenDom = document.querySelector('.personality-dark__art');
      this.screenPlaceholder = document.querySelector('.art-screen-placeholder');
    },
    showDarkScreens(type) {
      //如果正在转场，显示转场壁纸，隐藏占位壁纸
      if (type == 'transaction') {
        this.darkScreenDom.style.visibility = 'visible';
        this.screenPlaceholder.style.visibility = 'hidden';
        return;
      }
      // 转场回到暗色结束，显示占位壁纸，隐藏转场壁纸
      this.darkScreenDom.style.visibility = 'hidden';
      this.screenPlaceholder.style.visibility = 'visible';
    },
    computingStyles() {
      //获取art+模块手机外壳的位置信息
      let phone = document.querySelector('#artPhoneWap');
      let phonePosition = phone.getBoundingClientRect();
      //获取运动壁纸图片的位置信息
      this.screenPosition = this.screenPlaceholder.getBoundingClientRect();
      // // 计算出运动的距离
      this.delta.deltaWidth = phonePosition.width - this.screenPosition.width;
      this.delta.deltaHeight = phonePosition.height - this.screenPosition.height;
      this.delta.deltaX = phonePosition.left - this.screenPosition.left;
      this.delta.deltaY = phonePosition.top - this.screenPosition.top;
      this.delta.borderRadius = 13;
    },
    computingStylesOfText() {
      // 计算文字的运动距离
      let textHeight = this.$el.querySelector('.text-wrap').clientHeight;
      this.delta.textTransformMax = textHeight + (screen.availHeight - textHeight) / 2;
    },
    // 在 beforeDestroy 里面会报错，所以改用父级，调用 ref 的方式来保证顺序
    destoryScene() {
      this.darkScreenDom && this.showDarkScreens();
      if (this.scence) this.scence.destroy(true);
      if (this.scence2) this.scence2.destroy(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.personality-art {
  position: relative;
  height: 100vh;
  min-height: 780px;
  background: #100e0e;
  margin-top: -1px !important;
  &__screen-wrap {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 30px;
    .normal-screen {
      width: 282px;
      height: 618px;
      // opacity: 0.15;
      margin-right: 45px;
      border-radius: 27px;
      opacity: 1;
      transition: opacity 0.2s 0.3s linear;
    }
    .lowOpacity {
      opacity: 0.15;
      transition: opacity 0.2s 0.3s linear;
    }
  }
  &-phone {
    position: relative;
    width: 322px;
    height: 708px;
    margin-right: 50px;
    flex-shrink: 0;
    z-index: 10;
  }

  .screen {
    position: absolute;
    width: 308px;
    height: 682px;
    left: 50%;
    top: 11px;
    border-radius: 27px;
    transform: translate(-50%);
  }
  #phoneWap {
    position: absolute;
    z-index: 10;
    width: 322px;
    height: 708px;
    left: 357px;
    top: calc((100vh - 708px) / 2);
    .relaxPlacehold {
      opacity: 0;
    }
    .desktop {
      z-index: 10;
    }
    .phone {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 10;
    }
  }
  &__text {
    position: absolute;
    height: 100%;
    top: 0px;
    // 320px + 288px
    // left: calc(35.625vw + 215px);
    left: 900px;
    width: calc(100vw - 900px);
    min-width: 290px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    z-index: 20;
    box-sizing: border-box;
    padding-right: 50px;
    .title,
    .sub-title,
    .description {
      color: #fff;
      opacity: 0;
    }
    .description {
      max-width: 587px;
      color: rgba($color: #ffffff, $alpha: 0.55);
    }
    .logo-wrap {
      opacity: 0;
    }
    .art-logo {
      width: 116px;
      margin-top: 52px;
    }
    .artist-logo {
      width: 150px;
    }
  }
}
.screnn-big {
  display: none;
}
@media only screen and (min-width: 1950px) {
  .screnn-big {
    display: inline-block;
  }
  .personality-art {
    #phoneWap {
      left: 688px;
    }
  }

  .personality-art__text {
    left: 1295px;
    width: calc(100vw - 1295px);
  }
}
// 设置文字距离左边的最小值
@media only screen and (max-width: 1440px) {
  .personality-art {
    #phoneWap {
      width: 257.6px;
      height: 566.4px;
      left: 278px;
      top: calc(50vh - 268px);
    }
    .personality-art-phone,
    .screen {
      width: 246.6px;
      height: 545.4px;
      margin-right: 40px;
      top: 8px;
    }
  }
  .personality-art__screen-wrap {
    padding-left: 24px;
    .normal-screen {
      width: 225px;
      height: 489px;
      margin-right: 36px;
    }
  }
  .personality-art__text {
    left: 656px;
    width: calc(100vw - 656px);
  }
}
.personality-art-h5 {
  padding-bottom: 70px;
  position: relative;
  background: #00030a;
  .text-wrap {
    .title,
    .sub-title {
      color: #fff;
    }
    .description {
      color: rgba($color: #fff, $alpha: 0.5);
    }
  }
  ::v-deep.swiper-container {
    margin-top: 13px;
  }
  ::v-deep.swiper-slide {
    width: 182px;
    height: 397px;
    border-radius: 17px;
    overflow: hidden;
    opacity: 0.3;
    transition: opacity 0.3s linear;
    img {
      width: 100%;
      height: 100%;
    }
  }
  ::v-deep.swiper-slide-active {
    opacity: 1;
    transition: opacity 0.3s linear;
  }
  #phoneWap {
    position: absolute;
    width: 189px;
    height: 417px;
    left: 50%;
    margin-left: -94px;
    bottom: 58px;
    z-index: 1;
    pointer-events: none;
    .desktop {
      width: 181px;
      height: 403px;
      border-radius: 17.1894px;
      margin-top: 6px;
      margin-left: 4px;
    }
    .phone {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
// 英文样式
html:not([lang|='zh-CN']) {
  .js-trigger__text-in {
    .sub-title {
      max-width: 664px;
    }
    .description {
      max-width: 587px;
    }
  }
}
.artScreensIn {
  animation-name: artScreensIn;
  animation-timing-function: linear;
}
@keyframes artScreensIn {
  from {
    opacity: 0;
    transform: translate3d(0px, 90px, 0px);
  }
  66% {
    opacity: 1;
  }
  100% {
    transform: translate3d(0px, 0px, 0px);
  }
}
</style>
